import React from 'react';
import { Gift, Sparkles } from 'lucide-react';
const bonuses = [{
  id: 1,
  title: 'Bono #1 – Recetas Keto',
  desc: 'Para potenciar energía y quema de grasa',
  image: 'https://cdn.magicpatterns.com/uploads/ryhJs8ZUhNCL1TCUoytny8/bono_1_(2).png'
}, {
  id: 2,
  title: 'Bono #2 – Postres saludables',
  desc: 'Disfrutar sin culpa, sin azúcar ni gluten',
  image: 'https://cdn.magicpatterns.com/uploads/5PL3x9KKxizCCdEV9zuUDw/bono_2_(2).png'
}, {
  id: 3,
  title: 'Bono #3 – 150 Recetas Fit',
  desc: 'Opciones rápidas para todos los días',
  image: 'https://cdn.magicpatterns.com/uploads/mDvLRXVgBRhSkibUJJHThn/bono_3_(2).png'
}, {
  id: 4,
  title: 'Bono #4 – Postres en vaso sin TACC',
  desc: 'Deliciosos y seguros para celíacos',
  image: 'https://cdn.magicpatterns.com/uploads/hiKmhzsQAVJRhDesTn6EEd/bono_4_(2).png'
}, {
  id: 5,
  title: 'Bono #5 – Guía de Jugos Detox',
  desc: 'Limpieza profunda y natural',
  image: 'https://cdn.magicpatterns.com/uploads/naSiBmxYvk7z3tSDbbgwnW/bono_5_(2).png'
}, {
  id: 6,
  title: 'Bono #6 – Ayuno intermitente',
  desc: 'Explicado paso a paso para principiantes',
  image: 'https://cdn.magicpatterns.com/uploads/2gtCegbPayyTgC3qmBEZ2k/bono_6_(2).png'
}];
export function BonusSection() {
  return <section className="py-24 bg-[#18181B] text-white px-4 relative overflow-hidden" data-id="element-22">
      {/* Radial gradient background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-zinc-800 via-zinc-900 to-black opacity-80 pointer-events-none" data-id="element-23"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-24">
        <div className="text-center mb-20" data-id="element-25">
          <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/40 text-amber-400 font-bold px-6 py-2.5 rounded-full mb-8 uppercase tracking-wider text-sm md:text-base shadow-[0_0_15px_rgba(245,158,11,0.2)]" data-id="element-26">
            <Gift className="w-5 h-5" data-id="element-27" />
            Gratis por hoy
          </div>
          <h2 className="text-4xl md:text-6xl font-bold mb-6 text-white tracking-tight" data-id="element-28">
            🎁 BONOS INCLUIDOS
          </h2>
          <p className="text-xl text-gray-400 font-light max-w-2xl mx-auto" data-id="element-29">
            Complementos perfectos para potenciar los resultados del Manual
            <br data-id="element-30" />
            <span className="text-amber-500 font-medium drop-shadow-sm" data-id="element-31">
              (Sin costo adicional al ordenar ahora)
            </span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-32">
          {bonuses.map(bonus => <a key={bonus.id} href="https://checkot2.descargatop.com/cart/50167803609445:1" target="_blank" rel="noopener noreferrer" className="bg-zinc-900/50 backdrop-blur-sm rounded-3xl overflow-hidden hover:bg-zinc-800 transition-all duration-300 group border border-zinc-800 hover:border-amber-500/40 hover:shadow-[0_0_20px_rgba(245,158,11,0.1)] hover:-translate-y-1 flex flex-col h-full" data-id="element-33">
              {bonus.image ? <div className="aspect-square w-full bg-zinc-950 p-8 flex items-center justify-center relative overflow-hidden" data-id="element-34">
                  <div className="absolute inset-0 bg-gradient-to-t from-zinc-900 to-transparent opacity-60" data-id="element-35"></div>
                  {/* Vignette effect */}
                  <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_30%,rgba(0,0,0,0.8)_100%)] pointer-events-none" data-id="element-36"></div>

                  <img src={bonus.image} alt={bonus.title} className="max-h-full max-w-full object-contain group-hover:scale-105 transition-transform duration-500 drop-shadow-2xl relative z-10" data-id="element-37" />
                </div> : <div className="aspect-square w-full bg-zinc-950 flex flex-col items-center justify-center p-8 border-b border-zinc-800" data-id="element-38">
                  <span className="text-8xl mb-4 filter drop-shadow-lg transform group-hover:scale-110 transition-transform duration-300" data-id="element-39">
                    🎁
                  </span>
                </div>}

              <div className="p-8 flex-1 flex flex-col border-t border-white/5" data-id="element-40">
                <div className="inline-flex items-center gap-1 bg-gradient-to-r from-emerald-900 to-emerald-800 text-emerald-300 text-xs font-bold px-3 py-1.5 rounded-full mb-4 border border-emerald-700/50 w-fit shadow-sm" data-id="element-41">
                  <Sparkles className="w-3 h-3" data-id="element-42" />
                  GRATIS
                </div>
                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-amber-400 transition-colors" data-id="element-43">
                  {bonus.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed mt-auto" data-id="element-44">
                  {bonus.desc}
                </p>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}